import ReportWrapper from './ReportWrapper';
export default ReportWrapper; 



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/index.js